import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import $ from 'jquery';
import { SharedService } from '../shared.service';
import { localStorageService } from '../localstorage.service';
import { ApiService } from '../api.service';
import { Notification } from '../main-layout/main-layout.component';
import { CommonModule, NgClass, DatePipe } from '@angular/common';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MainService } from '../main.service';
import { Toaster } from '../interface.component';
import { ToasterService } from '../toaster/toaster.service';
import { PermissionsService } from '../permissions/permissions.service';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { PaginationComponent } from 'ngx-bootstrap/pagination';
import { AssignmentDetailsComponent } from '../../pages/assignments/assignment-details/assignment-details.component';
import { TrainingDetailsComponent } from '../../pages/training/training-details/training-details.component';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, NgClass, TooltipDirective, PaginationComponent, AssignmentDetailsComponent, TrainingDetailsComponent, DatePipe]
})
export class NotificationsComponent implements OnInit {
  notifications: any = [];
  count: any;
  unread_count: any;
  dataParams:any = {
    limit: 10,
    offset: 0
  };
  throttle = 300;
  scrollDistance = 0;
  // initialLoader:boolean;
  timezone: any = this._local.customGetItem('timezone');
  timezoneName: any = this._local.customGetItem('timezoneName');
subscription:any;
  notification_subscription:any;
  search: string = '';
  hadSearched = false;
  pageNumber = 1;
  filter = 0;
  selected_notification: any = {};
  number_of_pages = 0;
  new_notifications: any = {};
  paramSubscription: any;
  filterTimezones: any = [];
  country_id: any;
  timezones: any = [];
  notification_count = 0;
  private sub = new Subscription();
  adminProfile: any;

  constructor(
    public _shared: SharedService,
    private _local: localStorageService,
    public router: Router,
    public _api: ApiService,
    private modalService: BsModalService,
    public _toaster: ToasterService,
    private route: ActivatedRoute,
    private permissions: PermissionsService,
  ) { }

  get canSeeNotifications(): boolean {
    return this.permissions.salesPermissionFlags.canSeeNotifications;
  }

  ngOnInit() {
    this.adminProfile = this._local.customGetItem('admin_profile');
    // this.timezoneName = this._shared.getTimezoneList();
    // this.timezoneName = this.timezoneName.filter((timezone: any) => timezone.val == this.timezone)[0].offset;

    const params = this.getQueryParams(window.location.href);
    this.filter = params.filter ? params.filter : this.filter;
    this.pageNumber = params.page ? parseInt(params.page) : 1;
    this.search = params.search ? params.search : '';
    console.log("test")
    this.initialNotifications();

    const id = this.route.snapshot.paramMap.get('id');
      this._shared.timezoneName$.subscribe(response => {
        if (response && response.length) {
          this.filterTimezones = []
          const data = this._shared.getTimezoneList();
          for (var i = 0; i < data.length; i++) {
            if (data[i].val) {
              var tzOffset = (parseInt(data[i].val.substring(0, data[i].val.length - 2)) * 60) + parseInt(data[i].val.substring(data[i].val.length - 2));
              var timezoneHours = parseInt((parseInt((tzOffset + "")) / 60) + "");
              timezoneHours = timezoneHours < 0 ? (-1 * timezoneHours) : timezoneHours;
              var timezoneMinutes = (tzOffset % 60);
              timezoneMinutes = timezoneMinutes < 0 ? (-1 * timezoneMinutes) : timezoneMinutes;
              var timezoneString = (tzOffset < 0 ? "-" : "+") + (timezoneHours < 10 ? "0" : "") + timezoneHours + ":" + (timezoneMinutes < 10 ? "0" : "") + timezoneMinutes;
              this.filterTimezones.push({
                code: data[i].offset,
                name: data[i].name,
                tzOffset: tzOffset,
                timezoneString: timezoneString,
                country_id: data[i].country_id,
                val: data[i].val,
                offset: data[i].offset,
                zone: data[i].zone,
              });
            }
            if (i === data.length - 1) {
              this.timezoneName = this.filterTimezones && this.filterTimezones.find((id: any) => id.val == this.timezone)?.code;
              console.log(this.timezoneName);
            }
          }
        }
      });
      const data = this._shared.getTimezoneList();

      this.paramSubscription = this.route.queryParams.subscribe((params) => {
        this.timezone = params['timezone'];
        this.country_id = params['country_id'];
        if (!(this.filterTimezones && this.filterTimezones.length)){
          this.filterTimezones = this.timezones;
        }
        if (this.filterTimezones.length && this.country_id) {
          this.filterTimezones = this.filterTimezones.filter(
            (el: any) => (el.country_id == this.country_id || el.country_id == 0)
          );
        }
        this.timezoneName = this.filterTimezones && this.filterTimezones.find((id: any) => id.val == this.timezone)?.offset;
        console.log('test', this.timezoneName);
        // if (id) {
        //   this.getDoctor(id);
        // }
      });

      this.sub = this._shared.notificationCount$.subscribe(count => {
        if(this.notification_count != count){
          this.getNotifications()
        }
      this.notification_count = count;
    });

    // TODO: Check below notifications subscription
    // this.notification_subscription = this.mainService.notifications
    //   .subscribe((data:any)=>{
    //       setTimeout(() => {
    //         this.showNotification();
    //       }, 10);

    // this.subscription = this.dashboardService.markReadAllNotification.subscribe((data:any)=>{
    //   if(data.is_error == 0){
    //     console.log('init')
    //     this.initialNotifications();
    //   }
    // })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.notification_subscription) this.notification_subscription.unsubscribe();
  }

  getNotifications(){
    let params = {
      limit:this.dataParams.limit,
      offset: this.dataParams.offset
    };
    this._api.api(params, 'user/fetch_admin_notifications', "get")
      .subscribe((data:any)=>{
        console.log('scrolled')
        if(data.is_error == 0){
          this.notifications = this.decorateNotifications(data.data);
          this.count = data.total_count;
          this.unread_count = data.unread_count;
          this.number_of_pages = this.count;
          if (this.filter == 1) {
            this.number_of_pages = this.count - this.unread_count;
          } else if (this.filter == 2) {
            this.number_of_pages = this.unread_count;
          }
        }
      },(error:any)=>{
        console.log(error)
      })
  }

  initialNotifications(){
    // this.initialLoader = true;
      let params = {
        limit: this.dataParams.limit,
        offset: this.dataParams.offset,
        search_string: '',
        filter: this.filter
      };
      if (this.search && this.search.length > 0) {
        params['search_string'] = this.search;
        this.hadSearched = true;
      } else {
        this.hadSearched = false;
        // TODO: Check below code
        // delete params.search_string;
      }
      this._api.api(params, 'user/fetch_admin_notifications', 'get').subscribe((data:any)=>{
          if(data.is_error == 0){
            // this.initialLoader = false;
            console.log(data,"response")
            this.notifications = this.decorateNotifications(data.data);
            if (this.notifications && this.notifications.length > 0) {
              this.new_notifications = this.notifications[0];
              this.new_notifications.unread_count = data.unread_count;
              this.showNotificationDetails(this.notifications[0], 0);
            } else {
              this.router.navigate([], { queryParams: { search: this.search, page: this.pageNumber, filter: this.filter } });
            }
            this.count = data.total_count;
            this.unread_count = data.unread_count;
            // this._shared.notification_count = data.unread_count;
            this._shared.setNotificationCount(data.unread_count || 0);

            this.number_of_pages = this.count;
            if (this.filter == 1) {
              this.number_of_pages = this.count - this.unread_count;
            } else if(this.filter == 2) {
              this.number_of_pages = this.unread_count;
            }
          }
        },(error:any)=>{
          // this.initialLoader = false;
          console.log(error)
        })
  }

  onScrollDown() {
    this.dataParams.offset += 10;
    this.initialNotifications();
  }

  markRead(id:any, index:any){
    let params: any = {};
    if(id){
        params['an_id'] = id;
    }
    this._api.api(params,'user/read_admin_notifications', "post")
    .subscribe((data:any)=>{
      if (this.notifications[index]) {
        this.notifications[index].read_at = new Date();
        this.unread_count--;
      }
      if (index != 101) {
        // this.dashboardService.markReadAllNotification.next(data);
      }

      if(!index && !id){
        this.getNotifications();
        // this._shared.notification_count = data.unread_count;
        this._shared.setNotificationCount(data.unread_count || 0);
      }
    },(error:any)=>{
        console.log(error);
    })
  }

  navToNotification(notification: any, index: any) {
    this.markRead(notification.an_id, index);
    const meta_data = this.parseNotificationMetadata(notification.metadata);
    if (this.shouldRedirectNotificationToLead(notification, meta_data)) {
      this.redirectNotificationToLead(meta_data);
      return;
    }
    // console.log('CheckTypeToNavigate::', notification);
    // this.router.navigate(['/app/assignments/my-assignments/', notification.req_id]);
    switch (notification.notification_type) {
      case 6:
      case 15:
        // New Note Added.
        let training_note_added = typeof(notification.metadata) == 'string' ? JSON.parse(notification.metadata) : notification.metadata;
        this.router.navigate(['/app/training/details', training_note_added.training_id ? training_note_added.training_id : training_note_added.training]);
        break;
      default:
        const phase_notes = typeof(notification.metadata) == 'string' ? JSON.parse(notification.metadata) : notification.metadata;
        this.router.navigate(['/app/assignments/my-assignments/', notification.req_id]);
        break;
    }
  }
  showNotificationDetails(notification: Notification, index: any) {
    if (!notification.read_at || notification.read_at == null) {
      this.markRead(notification.an_id, index);
    }
    const meta_data = this.parseNotificationMetadata(notification.metadata);

    if (this.shouldRedirectNotificationToLead(notification, meta_data)) {
      this.redirectNotificationToLead(meta_data);
      return;
    }

    notification['req_id'] = meta_data?.req_id || meta_data.request_id || meta_data?.training_id || '';
    let param_id = null;
    //param_id = this._shared.getNotificationId(notification);
    param_id = notification.an_id;
    if (param_id) {
      this.selected_notification = {};
    }

    setTimeout(() => {
      this.selected_notification = notification;
      const reqid = meta_data?.req_id || meta_data.request_id || meta_data?.training_id;
      this.router.navigate(['/app/notifications', param_id], { queryParams: { reqid, search: this.search, page: this.pageNumber, filter: this.filter } });
    }, 100);

  }

  private shouldRedirectNotificationToLead(notification: any, metadata: any): boolean {
    return Number(this.adminProfile?.role_id || 0) > 16 &&
      notification?.notification_type === 50 &&
      !!metadata?.lead_id;
  }

  private redirectNotificationToLead(metadata: any): void {
    this.router.navigate(['/app/sales/my-leads-details'], {
      queryParams: {
        lead_id: metadata.lead_id,
        admin_id: this.adminProfile?.admin_id
      }
    });
  }

  private decorateNotifications(notifications: any[]): any[] {
    console.log("test",notifications)
    
    if (!notifications || !notifications.length) {
      return notifications;
    }
    if (this.canSeeNotifications) {
      notifications = notifications.filter(
        (notification: any) => notification?.notification_type === 50 || notification?.notification_type === '50'
      );
    }
    return notifications.map((notification: any) => {
      if (notification?.notification_type === 50) {
        const meta_data = this.parseNotificationMetadata(notification.metadata);
         console.log(meta_data)
        const additional_text = meta_data?.additional_text;
        if (additional_text) {
          notification.message = notification.message
            ? `${notification.message} ${additional_text}`
            : additional_text;
        }
      }
      return notification;
    });
  }

  private parseNotificationMetadata(metadata: any): any {
    if (!metadata) {
      return {};
    }

    if (typeof metadata !== 'string') {
      return metadata;
    }

    try {
      return JSON.parse(metadata);
    } catch (error) {
      console.log(error);
      return {};
    }
  }

  pageChanged(event: any) {
    this.pageNumber = event.page;
    this.dataParams.offset = (this.pageNumber - 1) * 10; 
    this.initialNotifications()
  }
  getSearchQueryString(searchObj: any) {
    var queryString = "";
    for (var key in searchObj) {
      // skip loop if the property is from prototype
      if (!searchObj.hasOwnProperty(key)) continue;
      queryString += (searchObj[key] ? (queryString ? "&" : "") + key + "=" + searchObj[key] : "");
    }
    return queryString;
  }
  getQueryParams(queryString: string){
    var params: any = {};
    var search_string = decodeURI(queryString).split("?")[queryString.split("?").length === 1 ? 0 : 1];
    
    var searchParts = search_string.split("&");
    for(var i = 0; i < searchParts.length; i++)
    {
        var paramParts = searchParts[i].split("=");
        params[paramParts[0]] = paramParts[1];
    }
    return params;
  }
  updateNewNotifications() {
    this.filter = 0;
    this.pageNumber = 1;
    this.search = '';
    this.initialNotifications();
    this.removeNotification();
  }
  showNotification() {
    $("#refreshPopup1").removeClass("refresh_popup_dismiss");
  }
  removeNotification() {
    $("#refreshPopup1").addClass("refresh_popup_dismiss");
  }
  deleteNotification(event: any, notification: Notification) {
    event.stopPropagation();
    event.preventDefault();

    const modelRef = this.modalService.show(ConfirmationModalComponent, {
          initialState: {
            extra_data: {
              label: `Are you sure, you want to delete this notification?`,
              hideNotes: true,
            },
          },
          class: 'modal-dialog-centered',
        });
        modelRef.content?.passEntry.subscribe((resp: any) => {
          if (resp.success) {
            const params = {
              an_id: notification.an_id
            };
            this._api.api(params, 'user/delete_admin_notifications', 'post')
              .subscribe((data: any) => {
                if (data.is_error == 0) {
                  this._toaster.showToaster(
                    'Success',
                    'Notification deleted successfully.',
                    'success'
                  );
                  //this.showNotification();
                  this.initialNotifications();
                }
              });
          }
        });
    
  }
  markNotificationAsRead(event: any, notification: Notification, index: number) {
    event.stopPropagation();
    event.preventDefault();
    this.markRead(notification.an_id, index);
  }
}
